import { useState, useEffect } from "react";
import { getMinutesFromFormattedHours, getFormattedHoursFromMins } from "src/Common/function";
import _ from "lodash";

import TotalTechItem from "./TotalTechItem";
import { TimesheetTableHeader, TimesheetTableFooter } from "./TimesheetTable";

const TotalTimesheet = ({ timesheetData }) => {
  const [totalRegularMinutes, setTotalRegularMinutes] = useState(0);
  const [totalTravelMinutes, setTotalTravelMinutes] = useState(0);
  const [totalOverMinutes, setTotalOverMinutes] = useState(0);

  const [techData, setTechData] = useState([]);

  useEffect(() => {
    let totalRegularTimeMinutes = 0;
    let totalTravelTimeMinutes = 0;
    let totalOverTimeMinutes = 0;

    const techList = [];

    for (let tech of timesheetData) {
      let technician = _.cloneDeep(tech);

      let regularTimeMinutes = 0;
      let travelTimeMinutes = 0;
      let overTimeMinutes = 0;

      if (tech?.timesheet) {
        for (let i = 0; i < tech.timesheet.length; i++) {
          regularTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].regularTime);
          travelTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].travelTime);
          overTimeMinutes += getMinutesFromFormattedHours(tech.timesheet[i].overTime);
        }

        technician.regularTime = getFormattedHoursFromMins(regularTimeMinutes);
        technician.travelTime = getFormattedHoursFromMins(travelTimeMinutes);
        technician.overTime = getFormattedHoursFromMins(overTimeMinutes);
      }

      totalRegularTimeMinutes += regularTimeMinutes;
      totalTravelTimeMinutes += travelTimeMinutes;
      totalOverTimeMinutes += overTimeMinutes;

      techList.push(technician);
    }

    setTechData(techList);

    setTotalRegularMinutes(totalRegularTimeMinutes);
    setTotalTravelMinutes(totalTravelTimeMinutes);
    setTotalOverMinutes(totalOverTimeMinutes);
  }, [timesheetData]);

  return (
    <div>
      <TimesheetTableHeader />
      <div className="overflow-y-auto max-h-[360px]">
        {techData.map((tech) => (
          <TotalTechItem
            key={tech.id}
            tech={tech}
          />
        ))}
      </div>
      <TimesheetTableFooter
        label="Total"
        regularMinutes={totalRegularMinutes}
        travelMinutes={totalTravelMinutes}
        overMinutes={totalOverMinutes}
      />
    </div>
  );
};

export default TotalTimesheet;
